<template>
    <div class="personal-information-wrapper">
        <div class="row">
            <div class="col-sm-12">
                <h3 class="text-left text-normal account-title">
                    Personal Information
                </h3>
            </div>
            <div class="col-md-12">
                <h3 class="text-left text-normal margin-bottom-20 col-md-6 col-sm-6 margin-top-0 account-subtitle" :class="{'col-xs-12' : editMode, 'col-xs-9' : !editMode}"> Update your Personal Information </h3>
                <div class="col-md-6 col-sm-6 col-xs-3 text-right" v-if="!editMode">
                    <div class="row edit-row">
                        <a href="#" @click.prevent="$router.push({name: editInformationRouteName})" class="edit-text">
                            Edit 
                        </a>     
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-if="editMode">
                <div class="text-left text-danger" v-if="errors.has('internalError')">
                    There was an error processing your personal information. Please try again later.
                </div>
            </div>
        </div>

        <div v-if="!editMode">
            <div class="row">
                <div class="form-group col-sm-6">
                    <label class="hh-input-label">First name</label>
                    <span class="form-control overflow-x" :class="!userData.first_name ? 'form-color' : ''">
                        {{userData.first_name}}
                    </span>
                </div>
                <div class="form-group col-sm-6">
                    <label class="hh-input-label">Last name</label>
                    <span class="form-control overflow-x" :class="!userData.first_name ? 'form-color' : ''">
                        {{userData.last_name}}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-12">
                    <label class="hh-input-label">Email</label>
                    <span class="form-control overflow-x" :class="!userData.email ? 'form-color' : ''">
                        {{userData.email}}
                    </span>
                </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12" v-if="userData.phone">
                    <label class="hh-input-label">Phone number</label>
                    <span class="form-control overflow-x" :class="!userData.phone ? 'form-color' : ''">
                       {{userData.phone}}
                    </span>
                </div>
            </div>
            <div class="row margin-top-20 hh-form-btn-wrapper justify-content-start" v-if="!isRegisteredUsingSocialMedia">
                <div class="form-group col-sm-5">
                <button type="submit" name="Change password" @click.prevent="$router.push({name: 'changePassword'})" :theRole="isOrganizer" class="btn btn-link p-0 m-0 align-baseline change-password-btn">
			        Change Password
		        </button>
                </div>
            </div>
        </div>

        <div v-if="editMode" class="margin-top-40 margin-bottom-20">
            <div class="row">
                <div class="form-group col-sm-6">
                    <input-label type="text" css-class="form-control" id="first_name" v-model="formData.first_name"
                           placeholder="First Name" required />
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('first_name')">
                            {{errors.get('first_name')}}
                        </div>
                    </div>
                </div>

                <div class="form-group col-sm-6">
                    <input-label type="text" css-class="form-control" id="last_name" v-model="formData.last_name"
                           placeholder="Last Name" required/>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('last_name')">
                            {{errors.get('last_name')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="!isRegisteredUsingSocialMedia">
                <div class="form-group col-sm-12">
                    <input-label type="text" css-class="form-control" id="email" v-model="formData.email"
                           placeholder="Email address" required />
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('email')">
                            {{errors.get('email')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-12">
                    <input-label css-class="form-control" v-model="formData.phone"
                           type="tel"
                           autocomplete="tel"
                           placeholder="Phone number"
                    />
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('phone')">
                            {{errors.get('phone')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="!isRegisteredUsingSocialMedia">
                <div class="form-group col-sm-12">
                    <PasswordContainer
                            v-model="formData.password"
                            autocomplete="current-password"
                            placeholder="Password"
                            label="Password"
                            :required="true"
                            :showHint="false"
                            :withLabel="true"
                    />
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('password')">
                            {{errors.get('password')}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import FormDate from './elements/FormDate'
  import InputLabel from './elements/InputLabel'
  import CurrencyInput from './elements/CurrencyInput'
  import PasswordContainer from './elements/PasswordContainer'

  export default {
    name: 'PersonalInformation',

    components: {
      FormDate,
      InputLabel,
      CurrencyInput,
      PasswordContainer,
    },

    props: {
      userData: {
        email: String,
        first_name: String,
        last_name: String,
        phone: String,
        informationType: String,
      },
      editMode: Boolean,
      editInformationRouteName: String,
      errors: Object,

      identities: Array,
    },

    data: () => {
      return {
        loading: false,
        isDateOfBirthValid: true,
        formData: {
          email: null,
          first_name: null,
          last_name: null,
          phone: null,
          opType: 'update',
        },
      }
    },

    beforeMount () {
      this.formData = { ...this.formData, ...this.userData }
    },

    mounted () {
      this.$emit('componentLoading', this.$options.name, false)
    },

    methods: {
      setDateOfBirthStatus (value) {
        this.isDateOfBirthValid = value
      },

      canSubmit () {
        return this.isDateOfBirthValid
      },
    },

    computed: {
      isRegisteredUsingSocialMedia () {
        return !_.isEmpty(this.identities)
      },
      
      isOrganizer() {
        if (!_.isEmpty(this.userData.roles) && this.userData.roles.includes('organizer')) {
          return true;
        }
        else {
            return false;
        }

      }
    },
  }
</script>

<style lang="scss" scoped>
  .personal-information-wrapper::v-deep {
    .justify-content-start {
      justify-content: flex-start !important;
    }

    .svg.eye {
      margin-bottom: 5px;
    }

    .form-control.overflow-x {
      height: 55px;
      padding: 12px;
      display: flex;
      align-items: center;
    }
  }
</style>